import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";

import { SearchFilter } from "components";
import { ISearchFilter, ISearchSubmitData } from "types";

import {
  searchFilterMetaSelector,
  doSearchFilter,
  searchFilterDataSelector,
  clearSearchFilterState,
} from "../state";

interface SearchFilterContainerProps extends ISearchFilter {
  id: string;
}

export const SearchFilterContainer: React.FC<SearchFilterContainerProps> = ({
  id,
  autosuggest,
  type,
  parentToolId,
}) => {
  const { status, error, hasSearched } = useSelector(
    searchFilterMetaSelector(id)
  );
  const results = useSelector(searchFilterDataSelector(id));
  const dispatch = useDispatch();

  const dispatchSearch = useCallback(
    (query: string) => {
      dispatch(
        doSearchFilter({
          id,
          data: { query, type },
          parentToolId,
        })
      );
    },
    [dispatch, id, type, parentToolId]
  );

  const dispatchClearState = () => {
    dispatch(clearSearchFilterState(id));
  };

  const handleSearch = (query: string) => {
    if (!query.length) {
      dispatchClearState();
      return;
    }

    // perform search
    dispatchSearch(query);
  };

  return (
    <SearchFilter
      id={id}
      clearState={dispatchClearState}
      onSearch={(data: ISearchSubmitData) => handleSearch(data.search)}
      status={status}
      error={error}
      results={results}
      autosuggest={autosuggest}
      hasSearched={hasSearched}
    />
  );
};
